<div class="modal-overlay" *ngIf="isVisible">
  <div class="campaign-banner" [style.background]="config.themeGradient">
    <button class="close-btn" (click)="closeBanner()">×</button>
    <div class="banner-content">
      <div class="tag">{{ config.bannerBadgeText }}</div>
      <h2>{{ config.title }}</h2>
      <p>{{ config.description }}</p>
      <button 
        class="primary-btn" 
        [style.background-color]="config.themeColor"
        (click)="onBannerClick()">
        Explore the Campaign
      </button>
    </div>
    <div class="banner-image"></div>
  </div>
</div>
